<script>
import {library} from '@fortawesome/fontawesome-svg-core';
import {faCaretDown} from '@fortawesome/free-solid-svg-icons';

import SignOut from '../icons/SignOut.vue';
import User from '../icons/User.vue';
import ShoppingCart from "../icons/ShoppingCart.vue";
import ChevronDown from "../icons/ChevronDown.vue";

export default {
    name: "MainNavigationRight",
    components: {ChevronDown, ShoppingCart, SignOut, User},
    data() {
        return {
            dropdown: '',
            cartCount: 0
        }
    },

    created() {
        library.add(faCaretDown);
    },

    filters: {
        formatMoney(amount) {
            return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        }
    },

    mounted() {
        const self = this;
        this.$router.beforeEach((to, from, next) => {
            self.dropdown = '';
            next();
        });

        document.querySelector('main').addEventListener('click', function () {
            self.dropdown = '';
        });

        window.events.$on('setCartCount', (qty) => this.cartCount = qty);
        window.events.$on('setCartTotal', (amount) => this.cartTotal = amount);
    },

    methods: {
        toggleDropdown(name) {
            this.dropdown = this.dropdown === name ? '' : name;
        },

        logout() {
            let self = this;
            this.$auth.logout({
                success: function () {
                    if (self.$router.currentRoute.name !== 'login') {
                        self.$router.push({name: 'login'});
                    }

                    localStorage.clear();
                    feedback("Signed Out", 'success');
                },
                error: function (error) {
                    console.error(error);
                }
            });
        },

        toggleCart(open = null) {
            window.events.$emit('toggleCart', open);
        },

        checkAccessCode() {
            if (localStorage.getItem('access_code') !== null) {
                this.toggleCart();
            } else {
                feedback(
                    "Access code is not available.",
                    "danger"
                );
            }
        }
    }
}
</script>

<template>
    <nav class="flex place-self-end">
        <ul class="flex flex-row space-x-2 sm:space-x-3 md:space-x-6" v-if="loggedIn() && $auth.user().details">
            <li class="relative flex items-center group flex-row">
                <button type="button" aria-label="User Dropdown Menu" @click.prevent="toggleDropdown('user')"
                        class="grid grid-cols-[1fr_auto] justify-between items-center w-full py-1.5 whitespace-nowrap text-leonard-black hover:text-leonard-green-hover opacity-100"
                >
                    Hello, {{ $auth.user().details.FirstName }}
                    <ChevronDown class="text-leonard-black group-hover:text-leonard-green-hover ms-1 w-4"/>
                </button>
                <ul class="absolute right-0 top-3 mt-4 py-2 px-4 shadow-md rounded z-10 group-hover:block bg-leonard-grey"
                    :class="{'dropdown-open': dropdown === 'user', 'text-left': loggedIn()}"
                    v-show="dropdown === 'user'"
                >
                    <li class="relative flex items-center group flex-row">
                        <router-link
                            :to="{name: 'account'}"
                            class="grid grid-cols-[1fr_auto] justify-between items-center w-full py-1.5 whitespace-nowrap text-leonard-black hover:text-leonard-green-hover opacity-100"
                        >
                            My Account
                            <User class="w-4 ml-6"></User>
                        </router-link>
                    </li>
                    <li class="relative flex items-center group flex-row">
                        <span role="button"
                              class="grid grid-cols-[1fr_auto] justify-between items-center w-full py-1.5 whitespace-nowrap text-leonard-black hover:text-leonard-green-hover opacity-100"
                              @click.prevent="logout"
                        >
                          Sign Out
                          <SignOut class="w-4 ml-6"></SignOut>
                        </span>
                    </li>
                </ul>
            </li>
            <li class="relative flex items-center group flex-row border-l-2 border-leonard-grey pl-2 sm:pl-3 md:pl-6"
                v-if="this.$route.params.step">
                <button
                    type="button"
                    aria-label="Shopping Cart"
                    class="grid grid-cols-[1fr_auto] gap-2 justify-between items-center w-full py-1.5 whitespace-nowrap text-leonard-black hover:text-leonard-green-hover opacity-100"
                    :class="{'has-items': cartCount > 0}"
                    v-if="$auth.user().details"
                    :data-count="cartCount"
                    @click="checkAccessCode()"
                >
                    <ShoppingCart/>
                    <span class="hidden sm:inline-block">My Cart</span>
                </button>
            </li>
        </ul>
        <ul class="flex flex-row items-center space-x-2 sm:space-x-3 md:space-x-6" v-else>
            <li class="relative flex items-center group flex-row">
                <router-link
                    :to="{name:'register'}"
                    class="font-medium transition-all duration-300 border-2 rounded-md inline-block py-2 px-3 md:px-4 bg-transparent border-leonard-green text-leonard-green hover:bg-leonard-green-hover hover:border-transparent hover:text-leonard-white focus:ring-leonard-green cursor-pointer"
                >
                    Register
                </router-link>
            </li>
            <li class="relative flex items-center group flex-row">
                <router-link
                    :to="{name:'login'}"
                    class="font-medium transition-all duration-300 border-2 rounded-md inline-block py-2 px-3 md:px-4 bg-leonard-green border-leonard-green text-leonard-white hover:bg-leonard-green-hover hover:border-transparent focus:ring-leonard-green cursor-pointer disabled:bg-leonard-green-disabled disabled:text-leonard-green disabled:cursor-not-allowed"
                >
                    Sign In
                </router-link>
            </li>
        </ul>
    </nav>
</template>

<style scoped lang="scss">
.has-items[data-count] {
    @apply relative;

    &::after {
        @apply absolute rounded-full text-xs bg-leonard-green text-leonard-white top-0 left-2.5 w-auto h-5 border-l-2 border-leonard-white place-content-center;
        aspect-ratio: 1/1;
        content: attr(data-count);
    }
}
</style>
